// extracted by mini-css-extract-plugin
export default {"container":"Employees_container__6+U+p","employees":"Employees_employees__uaBNw","employee":"Employees_employee__qh6Fj","quote":"Employees_quote__ZcIHU"};